import type { IButtonStyles, ITheme } from "@fluentui/react";
import {
  concatStyleSets,
  HighContrastSelector,
  memoizeFunction,
} from "@fluentui/react";

import type { StandardControlSemanticColors } from "@1js/acui-common";
import {
  commonHighContrastDisabledStyles,
  getStandardControlSemanticColorsWithTheme,
  textContainerClassName,
} from "@1js/acui-common";

export const getAppFlyoutAnchorStyles = memoizeFunction(
  (theme: ITheme, _: boolean, customStyles?: IButtonStyles): IButtonStyles => {
    const standardControlSemanticColors: StandardControlSemanticColors =
      getStandardControlSemanticColorsWithTheme(theme);
    const baseStyles = {
      root: {
        paddingRight: 11,
        paddingLeft: 11,
      },
      label: [
        textContainerClassName,
        {
          marginRight: 0,
          marginLeft: 8,
        },
      ],
      labelDisabled: [
        {
          color: standardControlSemanticColors.textDisabledColor,
        },
        commonHighContrastDisabledStyles,
      ],
      menuIcon: {
        height: 12,
        lineHeight: 12,
        width: 12,
        fill: standardControlSemanticColors.textColor,
        marginLeft: 4,
        marginRight: 0,
      },
      menuIconDisabled: {
        fill: standardControlSemanticColors.textDisabledColor,
        selectors: {
          [HighContrastSelector]: {
            opacity: 1,
          },
        },
      },
      rootChecked: {
        backgroundColor: standardControlSemanticColors.toggledBackgroundColor,
      },
    };

    return concatStyleSets(baseStyles, customStyles);
  }
);
